import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as UserIcon } from "../../../../images/svgs/icons/user.svg";
import { ReactComponent as PaymentIcon } from "../../../../images/svgs/icons/payment.svg";
import { ReactComponent as SecurityIcon } from "../../../../images/svgs/icons/security.svg";
import { ReactComponent as SettingsIcon } from "../../../../images/svgs/icons/settings.svg";
import { ReactComponent as ReferralProgramIcon } from "../../../../images/svgs/icons/referral-program.svg";
import { ReactComponent as DarkThemeIcon } from "../../../../images/svgs/icons/dark-theme.svg";
import { ReactComponent as LogoutIcon } from "../../../../images/svgs/icons/logout.svg";
import ToggleButton from "../../../ReusableComponents/ToggleButton";
import { toggleTheme } from "../../../../store/actions/theme";
import { setTabs } from "../../../../store/actions/users-settings";
import styles from "./styles.module.css";

const UserInfoPopOver = () => {
  const dispatch = useDispatch();
  const theme = useSelector(state => state.theme.mode);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    const theme = localStorage.getItem("theme");
    if (!theme) return localStorage.setItem('theme', 'light');
    dispatch(toggleTheme(theme));
    // eslint-disable-next-line
  }, [])

  const _setActiveTab = tab => dispatch(setTabs(tab))

  return (
    <div className={`${styles.userInfo} ${toggle && styles.active}`} onClick={() => setToggle(!toggle)}>
      <div className={styles.userIcon}>
        <UserIcon />
      </div>
      <div className={`${styles.modal} ${toggle && styles.toggle}`}>
        <div className={styles.userIntro}>
          <p className={styles.name}>Cameron Williamson</p>
          <p className={styles.email}>c.williamson@gmail.com</p>
        </div>
        <div className={styles.dropdownContent}>
          <p onClick={() => _setActiveTab(0)}><PaymentIcon /> Payment</p>
          <p onClick={() => _setActiveTab(1)}><SecurityIcon /> Security</p>
          <p onClick={() => _setActiveTab(2)}><SettingsIcon /> Settings</p>
          <p onClick={() => _setActiveTab(3)}><ReferralProgramIcon /> Referral Program</p>
          <div className={styles.darkThemeButton}>
            <p><DarkThemeIcon /> Dark Theme</p>
            <ToggleButton
              state={Boolean(theme === 'dark')}
              toggle={() => dispatch(toggleTheme(theme === 'light' ? 'dark' : 'light'))}
            />
          </div>
          <p><LogoutIcon /> Log Out</p>
        </div>
      </div>
    </div>
  )
}

export default UserInfoPopOver;